module.exports = __webpack_public_path__ + "static/img/tab-one-active.52fe3680.png";